import Splide from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";

/**
 * Splide Gallery
 */
function initSplideGalleryVideo(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;

	const galleries = root.querySelectorAll(".splide-gallery-video");

	galleries.forEach((gallery) => {
		const config = {
			type: "loop",
			gap: "27px",
			pagination: false,
			arrows: true,
			snap: false,
			autoWidth: true,
			autoplay: "pause",
			pauseOnHover: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
			interval: 6000,
			padding: "7.5%",
			speed: 700,
			breakpoints: {
				1024: { gap: "20px" },
				640: {
					padding: "7.5vw",
					gap: "16px",
					focus: "center",
				},
			},
		};

		const splideGalleryVideo = new Splide(gallery, config);
		splideGalleryVideo.mount({ Intersection });


	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSplideGalleryVideo());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-gallery-video", ($block) => {
		initSplideGalleryVideo($block && $block.jquery ? $block.get(0) : $block);
	});
}
